export const formatNumber = (v) => {
  if (v === null || v === undefined || v === "") return "-";
  const n = Number(v);
  if (Number.isNaN(n)) return String(v);
  return n.toLocaleString("id-ID");
};

export const formatCurrency = (v) => {
  if (v === null || v === undefined || v === "") return "-";
  const n = Number(v);
  if (Number.isNaN(n)) return String(v);
  return "Rp " + n.toLocaleString("id-ID");
};

export const compactNumber = (v) => {
  const n = Number(v);
  if (Number.isNaN(n)) return String(v ?? "-");
  if (Math.abs(n) >= 1e9) return (n / 1e9).toFixed(1) + " M";
  if (Math.abs(n) >= 1e6) return (n / 1e6).toFixed(1) + " Jt";
  if (Math.abs(n) >= 1e3) return (n / 1e3).toFixed(1) + " Rb";
  return n.toLocaleString("id-ID");
};
